import { Component, OnDestroy, AfterViewInit, Output, EventEmitter, ElementRef } from '@angular/core';
import { LocationStrategy } from '@angular/common';
import tinymce, { Editor } from 'tinymce';

@Component({
  standalone: true,
  selector: 'nggt-tiny-mce',
  template: '',
})
export class TinyMCEComponent implements OnDestroy, AfterViewInit {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Output() readonly editorKeyup = new EventEmitter<any>();

  editor?: Editor;

  constructor(
    private host: ElementRef,
    private locationStrategy: LocationStrategy,
  ) {}

  ngAfterViewInit() {
    tinymce
      .init({
        target: this.host.nativeElement,
        plugins: ['link', 'paste', 'table'],
        skin_url: `${this.locationStrategy.getBaseHref()}assets/skins/lightgray`,
        setup: (editor) => {
          this.editor = editor;
          editor.on('keyup', () => {
            this.editorKeyup.emit(editor.getContent());
          });
        },
        height: '320',
      })
      .catch((error: unknown) => console.error('TinyMCE editor initialization failed', error));
  }

  ngOnDestroy() {
    if (this.editor) tinymce.remove(this.editor);
  }
}
